<div style="display: flex; height: calc(100% - 90px);"
  [ngStyle]="{
    '--mat-form-field-filled-caret-color': 'rgba(253, 193, 0, 1.0)',
    '--mat-form-field-filled-focus-active-indicator-color': 'rgba(253, 193, 0, 1.0)',
    '--mat-form-field-filled-focus-label-text-color': 'rgba(253, 193, 0, 0.87)',
    '--mat-form-field-outlined-caret-color': 'rgba(253, 193, 0, 1.0)',
    '--mat-form-field-outlined-focus-outline-color': 'rgba(253, 193, 0, 1.0)',
    '--mat-form-field-outlined-focus-label-text-color': 'rgba(253, 193, 0, 0.87)',
    '--mat-form-field-focus-select-arrow-color': 'rgba(253, 193, 0, 0.87)'
  }">

  @if (verticalLeftShow) {
    @if (!verticalLeftIsVisible) {
      <div class="mat-divider-vertical" [ngClass]="{'backdrop-visible': isBackdropOkay}">
        @if (!verticalLeftFixed) {
          <button mat-icon-button (click)="changeLeftNavbarVisible()" style="margin-left: -20px;">
            <mat-icon>play_arrow</mat-icon>
          </button>
        }
      </div>
    }
    @if (!useLeftContent) {
      <div style="flex: 2;" class="content-left" [ngClass]="{'backdrop-visible': isBackdropOkay}">
        <!-- Profilbild / Mitarbeiterliste -->
        <div class="myList">
          <ng-content select=".listTemplate"></ng-content>
        </div>
      </div>
      @if (verticalLeftIsVisible) {
        <div class="mat-divider-vertical" [ngClass]="{'backdrop-visible': isBackdropOkay}">
          @if (!verticalLeftFixed) {
            <button mat-icon-button (click)="changeLeftNavbarVisible()" style="margin-left: -20px;">
              <mat-icon style="transform: rotate(180deg);">play_arrow</mat-icon>
            </button>
          }
        </div>
      }
    }
  }

  <div style="flex: 10;" [ngClass]="{'backdrop-visible': isBackdropOkay}" [style.flex]="(verticalRightIsVisible) ? '10' : '12'">
    <div [ngClass]="{'myEmployeeBg': isEveryoneSelected}" style="width: 100%; height: 100%;">
      <!-- Routed views go here -->
      <ng-content select=".routerOutletTemplate"></ng-content>
    </div>
  </div>

  @if (verticalRightShow) {
    <div class="mat-divider-vertical" [ngClass]="{'backdrop-visible': isBackdropOkay}">
      <button mat-icon-button (click)="changeRightNavbarVisible()" style="margin-left: -20px;">
        @if (verticalRightIsVisible) {
          <mat-icon>play_arrow</mat-icon>
        }
        @if (!verticalRightIsVisible) {
          <mat-icon style="transform: rotate(180deg);">play_arrow</mat-icon>
        }
      </button>
    </div>
    <div style="flex: 2; max-width: 350px;" [ngClass]="{'backdrop-visible': isBackdropOkay}" [style.flex]="(verticalRightIsVisible) ? '2' : '0'">
      <!-- Hauptkategorien -->
      <div style="height: 100%;">
        @if (verticalRightIsVisible) {
          <ng-content select=".mainMenuVertical"></ng-content>
        }
      </div>
    </div>
  }

</div>
